import { FC } from "react"
import { Box, Text } from "@chakra-ui/react";
import { useDnd, useDndAsset } from "domains/drag-and-drop";
import { TextPrompt } from "./textPrompt";
import { FilePrompt } from "./filePrompt";
import { LinkPrompt } from "./linkPrompt";
import { HtmlPrompt } from "./htmlPrompt";
import { formatPromptLabel } from "domains/draft-asset/draftPromptForm";

const prompt = {
  'text': TextPrompt,
  'file': FilePrompt,
  'link': LinkPrompt,
  'html': HtmlPrompt
}

export const PromptAsset: FC<{ isEditable: boolean }> = ({ isEditable }) => {
  const { asset, path } = useDndAsset();
  const { onSelectItem } = useDnd();

  if (!asset) {
    return null;
  }

  const Prompt = prompt[asset.data.prompt_for];

  return (
    <Box
      bg={"white"}
      position={"relative"}
      borderRadius={"lg"}
      borderWidth={"1px"}
      borderColor={"brand.500"}
      overflow={"hidden"}
    >
      <Box
        position={"absolute"}
        top={0}
        left={0}
        bg={"brand.500"}
        zIndex={1}
        px={3}
        py={1}
        width={"auto"}
        borderRadius="0 0 10px"
        display={"inline-block"}
      >
        <Text fontSize={"sm"} color={"white"} fontWeight={600}>{formatPromptLabel(asset.data.prompt_for)} Dropzone</Text>
      </Box>
      <Box
        onClick={isEditable ? (e) => onSelectItem(e, path) : null}
        id="dnd-asset"
        position={"relative"}
      >
        <Prompt isEditable={isEditable} />
      </Box>
    </Box>
  )
};
